import Link from "next/link"

import { baseUrl } from "@/lib/link-utils/link-utils"
import { cn } from "@/lib/utils"
import StoryblokAssetClient from "@/components/storyblok/common/StoryblokAssetClient"

export default function HeaderLogo({ logo, subtext, sbLocale, className }) {
  return (
    <Link
      prefetch={false}
      className={cn("flex shrink-0 flex-col", className)}
      rel="home"
      href={baseUrl(true, sbLocale)}
      aria-label={"Start"}
    >
      <StoryblokAssetClient
        asset={logo}
        className={"object-contain block h-[26px] w-[142px] transition-all duration-200 lg:h-[46px] lg:w-[256px]"}
        loading="eager"
        width={427}
        height={78}
      />

      <StoryblokAssetClient
        asset={subtext}
        className="mt-2 hidden h-[15px] w-[251px] lg:block"
        width={412}
        height={24}
      />
    </Link>
  )
}
